const hotelSelectedFilters = (state = {}, action) => {
    switch (action.type) {
        case 'SAVE_HOTEL_SELECTED_FILTERS':
            return action.hotelSelectedFilters
        default:
            return state
    }
}

export default hotelSelectedFilters;